const breakpoints = {
  mobile: 0,
  tablet: 768,
  desktop: 992,
  lgDesktop: 1200
};

export default breakpoints;
